import { WillAutoBackup as ReturnType } from "Types/Reducers";
import { willAutoBackup as actions } from "actions";
import { willAutoBackup as statuses } from "globalConstants";

const initialState = {
   status: statuses.off,
};

function willAutoBackup(state = initialState, { type, payload }: { type: typeof actions[keyof typeof actions]; payload: any }): ReturnType {
   switch (type) {
      case actions.setOn:
         return {
            ...state,
            status: statuses.on,
         };
      case actions.setOff:
         return {
            ...state,
            status: statuses.off,
         };
      default:
         return state;
   }
}

export { actions };
export { statuses };
export { willAutoBackup };
